import * as React from 'react';
import { Link as RouterLink, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell } from '@progress/kendo-react-grid';
import { Editor, EditorTools, EditorUtils } from '@progress/kendo-react-editor';
import * as $ from 'jquery';
import { fetchApi } from '../../services/api';
const DocumentTitle = require('react-document-title');

const { Bold, Italic, Underline,
    AlignLeft, AlignRight, AlignCenter,
    Indent, Outdent,
    OrderedList, UnorderedList,
    Undo, Redo, Link, Unlink } = EditorTools;

type Props = RouteComponentProps<{}>;

type State = {
    agreements: AgreementData[];
    agreementTitle: string;
    isLoading: boolean;
}

export interface AgreementData {
    AgreementId: number;
    AgreementVersion: number;
    Title: string;
    Active: boolean;
}

class AgreementTitleCell extends GridCell {
    render() {
        return (
            <td>
                <RouterLink style={{ color: '#007bff' }} to={`/agreement/${this.props.dataItem.AgreementId}/${this.props.dataItem.AgreementVersion}`}>
                    {this.props.dataItem.Title}
                </RouterLink>
            </td>
        );
    }
}

class DeactivateCell extends GridCell {
    render() {
        if (this.props.dataItem.Active === false) {
            return <td />
        }

        else {
            return (
                <td><button type="button" className="btn btn-sm btn-danger k-grid-remove-command" onClick={() => this.Deactivate(this.props.dataItem.AgreementId)}>Deactivate Agreement</button></td>
            );
        }
    }

    private Deactivate(agreementId: number) {
        if (confirm("Deactivate Agreement?")) {
            this.setState({ isLoading: true });
            fetchApi(`api/Agreement/Deactivate/${agreementId}`, {}, 'POST')
                .then(() => {
                    this.props.dataItem.Active = false;
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }
}

export default class Agreements extends React.Component<Props, State>{

    private editor: React.RefObject<Editor>;

    constructor(props: Props) {
        super(props);

        this.state = {
            agreements: [],
            agreementTitle: '',
            isLoading: false
        }

        this.editor = React.createRef();

        this.getAgreements = this.getAgreements.bind(this);
        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        this.getAgreements();
    }
   
    public render() 
    {     
        return <React.Fragment>
                <DocumentTitle title='Agreements' />
                      
                <div className="row"> 
                
                <h1>Registration Agreements</h1>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" data-toggle="modal" data-target=".notice-modal">New Agreement</button>
                    <div id="agreementModal" className="modal fade notice-modal" tabIndex={-1} role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">New Agreement</h4>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <h5>Title</h5>
                                    <span className="k-form-field">
                                        <input
                                            className="form-control input-group wide"
                                            type="text"
                                            name="Title"
                                            placeholder="Title"
                                            value={this.state.agreementTitle}
                                            onChange={(e) => this.setState({ agreementTitle: e.target.value })}
                                        />
                                    </span>
                                    <br />
                                    <Editor
                                        className="bg-light"
                                        ref={this.editor}
                                        tools={[
                                            [ Bold, Italic, Underline ],
                                            [ Undo, Redo ],
                                            [ Link, Unlink ],
                                            [ AlignLeft, AlignCenter, AlignRight ],
                                            [ OrderedList, UnorderedList, Indent, Outdent ]
                                        ]}
                                        contentStyle={{ height: 320 }}
                                        defaultContent="Type agreement here..."
                                    />
                                    <br />
                                    <button type="button" className="btn btn-primary float-right" onClick={this.save}>Create Agreement</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <br />
             
            <p>Active items will be displayed in the registration form.</p>                       
            
            {(this.state.isLoading && this.state.agreements.length != 0) &&
            
            <Grid data={this.state.agreements}>
                <Column field="AgreementTitle" title="Agreement Name" cell={AgreementTitleCell} />
                <Column field="Deactivate" title="Deactivate" cell={DeactivateCell} />
            </Grid> 
            
            }
            <h3 className = "text-center p-5"> No Agreements found, agreements are shown when children are registered. </h3>
    
        </React.Fragment>    
    }

    private save() {

        const view = this.editor.current.view;

        const data = {
            Title: this.state.agreementTitle,
            Body: EditorUtils.getHtml(view.state),
        }
        this.setState({ isLoading: true });
        fetchApi('api/Agreement/Create', data, 'POST')
            .then(() => {
                this.getAgreements();
                $("#agreementModal").modal('hide');
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    private getAgreements() {
        this.setState({ isLoading: true });
        fetchApi('api/Agreement/List')
            .then((data: AgreementData[]) => {
                this.setState({ agreements: data, isLoading: false });
            });
    }
}
